// extracted by mini-css-extract-plugin
export var freeGiftProduct = "styles-module--free-gift-product--1af22";
export var freeGiftProduct__checkbox = "styles-module--free-gift-product__checkbox--ec434";
export var freeGiftProduct__checkbox_unselected = "styles-module--free-gift-product__checkbox_unselected--1b0b1";
export var freeGiftProduct__image = "styles-module--free-gift-product__image--ed516";
export var freeGiftProduct__info = "styles-module--free-gift-product__info--048a7";
export var freeGiftProduct__price = "styles-module--free-gift-product__price--ab897";